import _ from 'lodash';

import { FieldInputType, numberFormatProps } from 'constants/fields';
import { DEFAULT_DECIMAL_SCALE, MAX_NUMBER_VALUE, MAX_PERCENTAGE_VALUE } from 'constants/number';

import { NUMERIC_FORMAT_PROPS, PATTERN_FORMAT_PROPS } from './DataFieldCDS.constants';

const DIGIT_SHIFT = 10;

export const getMinValue = ({ value, maxValue }) => Math.min(value, maxValue);

export const checkValue = ({ value, maxValue, minValue }) => {
  // e.g. +('-') -> NaN (typing of negative value)
  if (_.isNaN(value)) {
    return true;
  }

  return (value / DIGIT_SHIFT < maxValue || (value === 0 && maxValue === 0)) && value >= minValue;
};

export const doTypeDependingAction = ({
  value,
  formattedValue,
  type,
  maxValue,
  minValue,
  action,
}) => {
  // no restrictions for maxValue = null
  if (_.isNull(maxValue)) {
    return value;
  }

  switch (type) {
    case FieldInputType.CURRENCY:
    case FieldInputType.FLOAT:
    case FieldInputType.INT:
      return action({
        value: Number(value),
        maxValue: maxValue ?? MAX_NUMBER_VALUE,
        minValue: minValue ?? 0,
      });

    case FieldInputType.PERCENTAGE_RESTYLED:
      return action({
        value: Number(value),
        maxValue: maxValue ?? MAX_PERCENTAGE_VALUE,
        minValue: minValue ?? 0,
      });

    case FieldInputType.TEL:
    case FieldInputType.TEL_EXT:
      return formattedValue;

    default:
      return value;
  }
};

const INPUT_TYPE_TAGS = {
  isMaskFormat: [FieldInputType.SSN],
  isTelExtensionFormat: [FieldInputType.TEL_EXT],
  isCurrencyInputType: [FieldInputType.CURRENCY],
  isPercentageInputType: [FieldInputType.PERCENTAGE_RESTYLED],
  isPhoneType: [FieldInputType.TEL, FieldInputType.TEL_EXT],
};

export const getInputTypeTags = ({ type }) =>
  Object.fromEntries(
    Object.entries(INPUT_TYPE_TAGS).map(([key, value]) => [key, value.includes(type)]),
  );

export const NUMBER_FORMAT_INPUT_EVENT_SOURCE_TYPE = {
  PROP: 'prop',
  EVENT: 'event',
};

export const getIsPatternFormat = ({ type, format }) =>
  !!(format ?? numberFormatProps[type]?.format);

// A decimalScale passed to the field wins over the type's: integer and percentage types default to 0.
export const getNumberFormatProps = ({
  type,
  isPatternFormat,
  decimalScale,
  isCurrencyInputType,
  props,
}) =>
  isPatternFormat
    ? { ...numberFormatProps[type], ..._.omit(props, NUMERIC_FORMAT_PROPS) }
    : {
        fixedDecimalScale: isCurrencyInputType,
        ...numberFormatProps[type],
        decimalScale:
          decimalScale ?? numberFormatProps[type]?.decimalScale ?? DEFAULT_DECIMAL_SCALE,
        ..._.omit(props, PATTERN_FORMAT_PROPS),
      };
